import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import Highcharts from 'highcharts';
import Highstocks from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import Boost from 'highcharts/modules/boost';
import Annotations from 'highcharts/modules/annotations';
import Lollipop from 'highcharts/modules/lollipop';
import Dumbbell from 'highcharts/modules/dumbbell';
import More from 'highcharts/highcharts-more';
import { highchartsGlobalOptions } from './chartOptions';
import { Watermark } from './plugins';
if (typeof window !== 'undefined') {
  Highcharts.setOptions(highchartsGlobalOptions);
  Highstocks.setOptions(highchartsGlobalOptions);
  Boost(Highcharts);
  More(Highcharts);
  Dumbbell(Highcharts);
  Annotations(Highcharts);
  Lollipop(Highcharts);
  Watermark(Highcharts);
  Watermark(Highstocks);
}
var charts = {
  stockChart: {
    constructorType: 'stockChart',
    lib: Highstocks
  },
  chart: {
    constructorType: null,
    lib: Highcharts
  }
};
export var Chart = function Chart(_ref) {
  var options = _ref.options,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'chart' : _ref$type;
  var chartDef = charts[type];
  if (typeof options.watermark === 'undefined') options.watermark = {};
  if (typeof options.watermark.enabled === 'undefined') options.watermark.enabled = true;
  var additionalProps = chartDef.constructorType ? {
    constructorType: chartDef.constructorType,
    highcharts: chartDef.lib
  } : {
    highcharts: chartDef.lib
  };
  return React.createElement(HighchartsReact, _extends({
    options: options
  }, additionalProps));
};
export default memo(Chart);